module.exports = __webpack_public_path__ + "static/media/35-9.6061a2a6.mp3";